import {
    Controller
} from "stimulus"
import ready from '../ready'
import Swiper, { Navigation } from 'swiper/core';
import {outerHeight, querySelectorNext} from "../helpers";

export default class extends Controller
{
    static targets = ['prev', 'next']
    swiper

    get el()
    {
        return this.data.has('selector')
            ? this.element.querySelector(this.data.get('selector'))
            : this.element
    }

    get config()
    {
        let config = JSON.parse(this.data.get('config'))
        let defaults = {
            on: {
                init: () => this.handleInitialized(),
            }
        }
        if (this.hasPrevTarget && this.hasNextTarget) {
            defaults['navigation'] = {
                nextEl: this.nextTarget,
                prevEl: this.prevTarget,
            }
        }

        if (!config) {
            return defaults
        }



        return Object.assign(defaults, config)
    }

    get currentSlide() {
        return this.swiper.slides[this.swiper.realIndex]
    }


    /**
     * Dont load the carousel until all the assets (like fonts) are loaded.
     * Late font loads can shift element positions and break swiper.
     */
    connect()
    {
        if(this.data.get('defer')) {
            ready.then(this.init.bind(this))
        } else {
            this.init()
        }
    }

    init()
    {
        Swiper.use(Navigation)
        this.swiper = new Swiper(this.el, this.config)
        this.swiper.init()
    }


    handleInitialized()
    {
        this.element.classList.remove('invisible')
    }


    disconnect()
    {
        this.swiper.destroy()
    }

}


